import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, Target, Map, Calendar, MessageCircle, Video } from 'lucide-react';
const bonuses = [{
  id: 1,
  title: 'OFERTA MAGNÉTICA',
  desc: 'Aprende cómo crear una oferta que aumente el valor percibido de tu producto.',
  value: '$47',
  icon: Target
}, {
  id: 2,
  title: 'MAPA DE MONETIZACIÓN',
  desc: 'Descubre cómo crear diferentes fuentes de ingresos a partir de un mismo producto digital.',
  value: '$67',
  icon: Map
}, {
  id: 3,
  title: 'PLAN DE CONTENIDO DE 90 DÍAS',
  desc: 'Ideas y estrategia para vender usando Instagram durante los próximos 90 días.',
  value: '$97',
  icon: Calendar
}, {
  id: 4,
  title: 'MENSAJES QUE CONVIERTEN',
  desc: 'Plantillas de mensajes para responder interesados y facilitar el proceso de venta.',
  value: '$57',
  icon: MessageCircle
}, {
  id: 5,
  title: 'CLASE ESPECIAL: MI ESTRATEGIA DE TIKTOK LIVE',
  desc: 'Acceso a una grabación donde comparto la metodología que utilizo para promocionar mis productos mediante TikTok Live.',
  value: '$197',
  icon: Video
}];
export function ValueStack() {
  return <section className="py-24 px-6 bg-brand-bgDeep relative" data-id="element-105">
      <div className="max-w-4xl mx-auto" data-id="element-106">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-107">
          <h2 className="text-3xl md:text-5xl font-black uppercase text-brand-navy mb-4 leading-tight" data-id="element-108">
            Lo que <span className="text-brand-accent" data-id="element-109">recibes hoy</span>
          </h2>
        </motion.div>

        {/* Main Guide */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-navy text-white rounded-3xl p-8 md:p-10 mb-8 relative overflow-hidden shadow-2xl" data-id="element-110">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-accent/30 rounded-full blur-3xl -mr-20 -mt-20" data-id="element-111"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-brand-accentLight/20 rounded-full blur-3xl -ml-10 -mb-10" data-id="element-112"></div>

          <div className="relative z-10" data-id="element-113">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-accent text-white text-sm font-bold tracking-wider mb-6 shadow-md" data-id="element-114">
              <BookOpen className="w-4 h-4" data-id="element-115" />
              GUÍA PRINCIPAL
            </div>
            <h3 className="text-3xl md:text-5xl font-black uppercase mb-4 leading-tight" data-id="element-116">
              "De Idea{' '}
              <span className="text-brand-accentLight" data-id="element-117">a Ingresos</span>"
            </h3>
            <p className="text-lg text-white/80 mb-8 max-w-2xl" data-id="element-118">
              Aprende el paso a paso para crear tu primer producto digital desde
              cero.
            </p>
            <div className="inline-block bg-white text-brand-navy px-6 py-2 rounded-lg font-black text-xl" data-id="element-119">
              Valor: $97
            </div>
          </div>
        </motion.div>

        {/* Bonuses */}
        <div className="space-y-6" data-id="element-120">
          {bonuses.map((bono, index) => <motion.div key={bono.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start md:items-center border-2 border-brand-cardDark/40 shadow-sm hover:shadow-md transition-shadow" data-id="element-121">
              <div className="w-16 h-16 rounded-2xl bg-brand-accent flex items-center justify-center shrink-0 shadow-md shadow-brand-accent/30" data-id="element-122">
                <bono.icon className="w-8 h-8 text-white" data-id="element-123" />
              </div>

              <div className="flex-1" data-id="element-124">
                <div className="inline-flex items-center gap-1.5 bg-brand-navy text-white px-3 py-1 rounded-md font-bold text-xs tracking-wider mb-3" data-id="element-125">
                  <Gift className="w-3.5 h-3.5" data-id="element-126" />
                  BONO #{bono.id}
                </div>
                <h4 className="text-xl md:text-2xl font-black uppercase text-brand-navy mb-2 leading-tight" data-id="element-127">
                  {bono.title}
                </h4>
                <p className="text-brand-textSoft leading-relaxed" data-id="element-128">
                  {bono.desc}
                </p>
              </div>

              <div className="md:text-right shrink-0" data-id="element-129">
                <div className="text-sm text-brand-textSoft font-medium mb-1" data-id="element-130">
                  Valor
                </div>
                <div className="text-3xl font-black text-brand-accent" data-id="element-131">
                  {bono.value}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}